
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/awsfargate",
      function () {
        return require("private-next-pages/services/awsfargate/index.tsx");
      }
    ]);
  